import { Button } from '@eb/eds-button';
import { setWindowLocation } from '@eb/http';
import React from 'react';

interface ActionWrapperProps {
    path: string;
    shouldOpenNewTab?: boolean;
    onClick?: () => void;
}

const handleClick = ({
    path,
    onClick,
}: {
    path?: string;
    onClick?: () => void;
}) => {
    onClick?.();

    if (path) setWindowLocation(path);
};

export const ActionWrapper: React.FunctionComponent<ActionWrapperProps> = (
    props,
) => {
    if (props.onClick && !props.shouldOpenNewTab) {
        return (
            <Button
                type="link"
                style="none"
                role="link"
                onClick={() => {
                    handleClick({ path: props.path, onClick: props.onClick });
                }}
            >
                {props.children}
            </Button>
        );
    }

    let aProps: Record<string, string | (() => void)> = { href: props.path };

    if (props.shouldOpenNewTab) {
        aProps = {
            ...aProps,
            target: '_blank',
            rel: 'noopener',
        };
    }

    if (props.onClick) {
        aProps = {
            ...aProps,
            onClick: () => handleClick({ onClick: props.onClick }),
        };
    }

    return <a {...aProps}>{props.children}</a>;
};
